// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

//import { getStorage } from "firebase/storage"
import { getFirestore } from "firebase/firestore"
//import { getAuth} from "firebase/auth"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBO19lJw4r3UzvnJ0iTfVD8_93yR1AMq94",
  authDomain: "franco-dev-c9c39.firebaseapp.com",
  projectId: "franco-dev-c9c39",
  storageBucket: "franco-dev-c9c39.firebasestorage.app",
  messagingSenderId: "243367221753",
  appId: "1:243367221753:web:28580d78b11de5789e8528",
  measurementId: "G-4R7JPQW5QD"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);


export const timeStamp = getFirestore(app)
//export const auth = getAuth(app)
export const db = getFirestore(app)
//export const storage = getStorage(app)
